<template>
    <!-- 相机租赁路由 -->
    <router-view></router-view>
</template>

<script>
export default {
    
}
</script>
